"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_ACTION_CODE = exports.EXPIRED_ACTION_CODE = exports.USER_NOT_FOUND = exports.INCORRECT_PASSWORD = void 0;
exports.INCORRECT_PASSWORD = "auth/wrong-password";
exports.USER_NOT_FOUND = "auth/user-not-found";
exports.EXPIRED_ACTION_CODE = "auth/expired-action-code";
exports.INVALID_ACTION_CODE = "auth/invalid-action-code";
